/**
 * @generated SignedSource<<c8398b4dae7e7688868aa53f3e5b25a0>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NavExpandingAreaItem_notifications$data = {
  readonly " $fragmentSpreads": FragmentRefs<"NavItemVATReportLink_notifications" | "NavItem_notifications">;
  readonly " $fragmentType": "NavExpandingAreaItem_notifications";
};
export type NavExpandingAreaItem_notifications$key = {
  readonly " $data"?: NavExpandingAreaItem_notifications$data;
  readonly " $fragmentSpreads": FragmentRefs<"NavExpandingAreaItem_notifications">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NavExpandingAreaItem_notifications",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NavItem_notifications"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NavItemVATReportLink_notifications"
    }
  ],
  "type": "DealerNavBarBadges",
  "abstractKey": null
};

(node as any).hash = "a6ff3318f2669fa567924e497ea9aaf3";

export default node;
